import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { getSchoolRegistrationFormSchemaUrl, getCommunityRegistrationFormSchemaUrl, getIndependentRegistrationFormSchemaUrl, } from './config';
// Preload registration form schemas for caching
// This triggers the fetch early so they're cached when components need them
const preloadFormSchemas = () => {
    // Preload school registration form schema
    const schoolSchemaUrl = getSchoolRegistrationFormSchemaUrl();
    fetch(schoolSchemaUrl, {
        method: 'GET',
        cache: 'force-cache' // Use cached version if available
    }).catch(err => {
        // Silent fail - SchoolRegistration will handle the error when it fetches
        console.warn('Failed to preload school form schema:', err);
    });
    // Preload community registration form schema
    const communitySchemaUrl = getCommunityRegistrationFormSchemaUrl();
    fetch(communitySchemaUrl, {
        method: 'GET',
        cache: 'force-cache' // Use cached version if available
    }).catch(err => {
        // Silent fail - CommunityRegistration will handle the error when it fetches
        console.warn('Failed to preload community form schema:', err);
    });
    // Preload independent registration form schema
    const independentSchemaUrl = getIndependentRegistrationFormSchemaUrl();
    fetch(independentSchemaUrl, {
        method: 'GET',
        cache: 'force-cache' // Use cached version if available
    }).catch(err => {
        // Silent fail - IndependentRegistration will handle the error when it fetches
        console.warn('Failed to preload independent form schema:', err);
    });
};
// Start preloading immediately
preloadFormSchemas();
const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
